'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ViewMode, ViewModePropType} from '../../../core-utilities/enums/ViewMode';

const loadingIcon = require('../../../../img/loading.svg');

export function LoadMoreComponent(props) {
  return props.mode !== ViewMode.LOADING_MORE ? null : (
    <div className={classNames("loading-more-container", props.className)}>
      <img
        className="loading-more"
        src={loadingIcon}
      />
    </div>
  );
}

LoadMoreComponent.propTypes = {
  className: T.string,
  mode: ViewModePropType.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/components/LoadMoreComponent.js